// Libraries
var React = require('react');
var $ = require('jquery');

// Styles
require('./PossessionStats.scss');

// Assets
var spinner = require('images/Rolling.svg');

// Components
var DoughnutChart = require('DoughnutChart/DoughnutChart');
var BarChart = require('BarChart/BarChart');

class PossessionStatsModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			data: null
		}
	}

	componentDidMount() {
		// delay the load of the realtime library until it's reached the browser 
		// to avoid server side rendering errors
		this.Realtime = require('../../../common/Realtime/Realtime');

		this.loadData();
		this.attachChannels();
	}

	loadData = () => {
		$.ajax({
			method: "GET",
			url: this.props.data.endpoints.find(x => x.name === "footballStats").url
		})
			.done(data => {
				this.populateData(data);
			})
			.fail(data => {
				this.setState({ isLoading: false });
			});
	}

	populateData = (data) => {
		let config = {
			possessionValues: [data.Home.Possession, data.Away.Possession],
			cornersValues: [data.Home.Corners, data.Away.Corners],
			attemptsValues: [data.Home.Attempts, data.Away.Attempts],
			foulsValues: [data.Home.Fouls, data.Away.Fouls],
			yelowCardsValues: [data.Home.YellowCards, data.Away.YellowCards],
			redCardsValues: [data.Home.RedCards, data.Away.RedCards],
			offsideValues: [data.Home.Offside, data.Away.Offside],
			attemptsOnValues: [data.Home.AttemptsOn, data.Away.AttemptsOn],
			attemptsOffValues: [data.Home.AttemptsOff, data.Away.AttemptsOff],
			labels: [data.Home.ShortName, data.Away.ShortName],
			innerText: data.Minutes,
			innerTextSub: "Minutes",
			showLegend: true,
			homeColour: data.Home.Colour,
			awayColour: data.Away.Colour
		}

		this.setState({ isLoading: false, data: config, allData: data });
	}

	attachChannels() {
		let channel = this.props.data.endpoints.find(x => x.name === "footballStats").channelId;

		this.Realtime.subscribe(channel, this.props.data.realtimeKey, (message) => {
			this.populateData(message.data);
		});
	}

	render() {
		return (
			<div className="PossessionStats">
				<h2 tabIndex="0">Possession Stats</h2>
				{this.state.isLoading &&
						<img src={spinner} className="spinner" alt="Loading animation" />
				}
				{!this.state.isLoading && this.state.data === null &&
						<p tabIndex="0">Possession stats will be available once the match starts.</p>
				}
				{this.state.data &&
						<div className="PossessionStats__graph--left">
							<DoughnutChart id={this.props.data.id} data={this.state.data} ariaDoughnutInner={this.state.data.innerText + " " + this.state.data.innerTextSub + " played"} ariaDoughnutLabels={[this.state.allData.Home.Name + " " + this.state.data.possessionValues[0] + "% possession", this.state.allData.Away.Name + " " + this.state.data.possessionValues[1] + "% possession"]} />
						</div>
				}

				<div className="PossessionStats__graph--right">
					{this.state.data && this.state.data.cornersValues &&
							<BarChart data={{title: "Corners", values: this.state.data.cornersValues}} homeColour={this.state.data.homeColour} awayColour={this.state.data.awayColour} ariaDescriptionHome={this.state.allData.Home.Name + " " + this.state.data.cornersValues[0]} ariaDescriptionAway={this.state.allData.Away.Name + " " + this.state.data.cornersValues[1]} />
					}
					{this.state.data && this.state.data.attemptsValues &&
							<BarChart data={{title: "Attempts", values: this.state.data.attemptsValues}} homeColour={this.state.data.homeColour} awayColour={this.state.data.awayColour} ariaDescriptionHome={this.state.allData.Home.Name + " " + this.state.data.attemptsValues[0]} ariaDescriptionAway={this.state.allData.Away.Name + " " + this.state.data.attemptsValues[1]} />
					}
					{this.state.data && this.state.data.foulsValues &&
							<BarChart data={{title: "Fouls", values: this.state.data.foulsValues}} homeColour={this.state.data.homeColour} awayColour={this.state.data.awayColour} ariaDescriptionHome={this.state.allData.Home.Name + " " + this.state.data.foulsValues[0]} ariaDescriptionAway={this.state.allData.Away.Name + " " + this.state.data.foulsValues[1]} />
					}
					{this.state.data && this.state.data.yelowCardsValues &&
							<BarChart data={{title: "Yellow cards", values: this.state.data.yelowCardsValues}} homeColour={this.state.data.homeColour} awayColour={this.state.data.awayColour} ariaDescriptionHome={this.state.allData.Home.Name + " " + this.state.data.yelowCardsValues[0]} ariaDescriptionAway={this.state.allData.Away.Name + " " + this.state.data.yelowCardsValues[1]} />
					}
					{this.state.data && this.state.data.redCardsValues &&
							<BarChart data={{title: "Red cards", values: this.state.data.redCardsValues}} homeColour={this.state.data.homeColour} awayColour={this.state.data.awayColour} ariaDescriptionHome={this.state.allData.Home.Name + " " + this.state.data.redCardsValues[0]} ariaDescriptionAway={this.state.allData.Away.Name + " " + this.state.data.redCardsValues[1]} />
					}
					{this.state.data && this.state.data.offsideValues &&
							<BarChart data={{title: "Offside", values: this.state.data.offsideValues}} homeColour={this.state.data.homeColour} awayColour={this.state.data.awayColour} ariaDescriptionHome={this.state.allData.Home.Name + " " + this.state.data.offsideValues[0]} ariaDescriptionAway={this.state.allData.Away.Name + " " + this.state.data.offsideValues[1]} />
					}
					{this.state.data && this.state.data.attemptsOnValues &&
							<BarChart data={{title: "Attempts on", values: this.state.data.attemptsOnValues}} homeColour={this.state.data.homeColour} awayColour={this.state.data.awayColour} ariaDescriptionHome={this.state.allData.Home.Name + " " + this.state.data.attemptsOnValues[0]} ariaDescriptionAway={this.state.allData.Away.Name + " " + this.state.data.attemptsOnValues[1]} />
					}
					{this.state.data && this.state.data.attemptsOffValues &&
							<BarChart data={{title: "Attempts off", values: this.state.data.attemptsOffValues}} homeColour={this.state.data.homeColour} awayColour={this.state.data.awayColour} ariaDescriptionHome={this.state.allData.Home.Name + " " + this.state.data.attemptsOffValues[0]} ariaDescriptionAway={this.state.allData.Away.Name + " " + this.state.data.attemptsOffValues[1]} />
					}
				</div>

			</div>
		)
	}
}

module.exports = PossessionStatsModule;



// WEBPACK FOOTER //
// ./src/components/MDC/PossessionStats/PossessionStatsModule.js